import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '@abp/ng.core';

@Pipe({
  name: 'enumLocalization',
  standalone: false,
})
export class EnumLocalizationPipe implements PipeTransform {
  constructor(private localizationService: LocalizationService) {}
  transform(value: any, enumWrapper: { [key: string]: any }): string {
    if (value === null || value === undefined || !enumWrapper) {
      return '';
    }

    const enumName = Object.keys(enumWrapper)[0];
    const enumType = enumWrapper[enumName];

    if (!enumType) return '';

    const enumKey = enumType[value];

    if (!enumKey) {
      return value.toString();
    }

    const localizationKey = `Enum::${enumName}:${enumKey}`;
    return this.localizationService.instant(localizationKey);
  }
}
